<template>
    <head>
        <meta charset="utf-8">
        <meta content="width=device-width, initial-scale=1.0" name="viewport">

        <title>Smart App - Megacad</title>
        <meta content="" name="description">
        <meta content="" name="keywords">
    </head>

    <body>

        <Header />

        <Sidebar />

        <main id="main" class="main">
            <slot></slot> 
        </main>

        <Footer />

        <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

    </body>
  </template>
  
  <script>

  import Header from './Header.vue';
  import Footer from './Footer.vue';
  import Sidebar from './Sidebar.vue';

  export default {
    name: 'MainLayout',

    components: {
        Header,
        Footer,
        Sidebar,
    },

    data() {

        return {

            name: '',
        };
    },

    mounted() {
    },
  };
  </script>
  
  